// @flow

// prettier-ignore

export default {
  Accept: '수용하다',
  AcceptRegistration: '등록 수락',
  AcceptTermsOfAccess_SentenceCase: '접근 조건 수락',
  Access: '입장',
  AccessAllowed: '접근 허용됨',
  AccessDenied: '접근 불가',
  AccessedAgo: '[time]에 액세스했습니다.',
  Actions: '작업',
  Add: '추가하다',
  AddAndInvite: '추가하고 초대하세요',
  AddAndInvitePeople: '사람 추가 및 초대',
  AdditionalRecipients: '추가 수신자',
  AdditionalRecipients_SentenceCase: '추가 수신자',
  AdditionalRecipientsHint: '각 이메일 주소를 별도의 줄에 입력하세요',
  AddPeople: '사람 추가',
  AddPeopleTo: '사람을 추가하세요',
  AddPeopleToSubteam: '[Team]/[Subteam]에 사람 추가',
  AddPeopleToTeam: '[Team]에 사람 추가',
  AddPeopleWillHaveTheSameAccess: '추가된 사람은 동일한 액세스 권한을 갖습니다.',
  AddToExistingTeam: '기존 팀에 추가',
  Administration: '관리',
  AdminSideAudit: '팀',
  AdminSideBankruptcy: '판매 측',
  AdminSideBankruptcy_EmailHeading: '판매 측 사람들에게 이메일 보내기',
  AdminSideBankruptcy_InviteHeading: '판매 측 사람들에게 초대장을 보내세요',
  AdminSideDebt: '발행자',
  AdminSideDebt_EmailHeading: '이메일 발급자',
  AdminSideDebt_InviteHeading: '발급자에게 초대장 보내기',
  AdminSideDocumentRepository: '내부',
  AdminSideDocumentRepository_EmailHeading: '이메일 내부',
  AdminSideDocumentRepository_InviteHeading: '내부자에게 초대장 보내기',
  AdminSideFundraising: '고객',
  AdminSideFundraising_EmailHeading: '이메일 클라이언트',
  AdminSideFundraising_InviteHeading: '클라이언트에게 초대장 보내기',
  AdminSideInternalAudit: '팀',
  AdminSideJointVenture: '내부',
  AdminSideJointVenture_EmailHeading: '이메일 내부',
  AdminSideJointVenture_InviteHeading: '내부자에게 초대장 보내기',
  AdminSideMerger: '판매 측',
  AdminSideMerger_EmailHeading: '판매 측 사람들에게 이메일 보내기',
  AdminSideMerger_InviteHeading: '판매 측 사람들에게 초대장을 보내세요',
  AdminSideOther: '내부',
  AdminSideOther_EmailHeading: '이메일 내부',
  AdminSideOther_InviteHeading: '내부자에게 초대장 보내기',
  AdminSidePlacement: '발행자',
  AdminSidePlacement_EmailHeading: '이메일 발급자',
  AdminSidePlacement_InviteHeading: '발급자에게 초대장 보내기',
  AdminSidePublicOffer: '내부',
  AdminSidePublicOffer_EmailHeading: '이메일 내부',
  AdminSidePublicOffer_InviteHeading: '내부자에게 초대장 보내기',
  AdminSideTargeted: '내부 팀',
  AdminSideTargeted_EmailHeading: '내부 팀에 이메일 보내기',
  AdminSideTargeted_InviteHeading: '내부 팀에 초대장 보내기',
  AdminSideTax: '팀',
  AdminSideTender: '고객',
  AdminSideTender_EmailHeading: '이메일 클라이언트',
  AdminSideTender_InviteHeading: 'Send invites to client',
  All: '모두',
  Allow: '허용하다',
  Allowed: '허용된',
  AlwaysInviteGuestDialogContent:
    '계획을 변경하려면 Ansarada 에 연락해야 합니다. 걱정하지 마세요. 곧 외부 사람들에게 초대장을 보낼 수 있을 겁니다.',
  And_SentenceCase: '그리고',
  AndGoLive: '그리고 라이브로 가다',
  AreYourReadyToGoLive: '라이브 방송을 시작할 준비가 되셨나요?',
  AreYouSureToDeclineRegistration: '등록자 [registrant] 을 거부하시겠습니까?',
  AreYouSureToDeleteRegistration: '등록자 [registrant] 을 삭제하시겠습니까?',
  AreYouSureToDeleteRequest: '[registrant] 요청을 삭제하시겠습니까?',
  At: '~에',
  Attachments: '첨부문서',
  BackToTeamsPage: '팀 페이지로 돌아가기',
  BannerMessage: "[TeamName] 의 설정으로 생성된 팀",
  BatchOperationCantBePerformed:
    '해당 데이터룸에 사용자가 없으므로 일괄작업이 수행될 수 없습니다. 먼저 사용자를 입력 하십시오.',
  BeforeYouCanEmail: '[teamType] 으로 이메일을 보내려면 먼저 이메일을 인증해야 합니다.',
  BeforeYouCanGoLive: '라이브로 전환하기 전에',
  BeforeYouCanSendInvites:
    '[teamType] 에 초대장을 보내려면 이메일을 인증해야 합니다.',
  BidderEditSecurityBannerMessage: '입찰자는 보안 제어가 활성화된 문서를 반환할 수 없습니다.',
  BillingCommencesWhenTheFirstGuestIsInvited: '첫 번째 투숙객이 초대되면 요금 청구가 시작됩니다.',
  BulkDownload_SentenceCase: '대량 다운로드',
  BulkDownloadText:
    '사람들이 여러 파일을 단일 .zip 파일로 다운로드할 수 있도록 합니다. Zip 다운로드는 제한된 시간 동안만 가능합니다.',
  BuySide: '매수 측',
  BuySide_InviteHeading: '구매측 사람들에게 초대장을 보내세요',
  BuySide_SentenceCase: '매수 측',
  BySubmittingThisForm: '이 양식을 제출하면 귀하는 당사의 내용에 동의하는 것입니다.',
  Cancel: '취소',
  Change: '변경',
  ChangeTeamAccess: '팀 액세스 변경',
  ChooseLanguage: '언어 선택',
  ClickAndPreview: '2. 클릭하고 미리 보기',
  Close: '닫기',
  CollapseAll_SentenceCase: '모두 접기',
  Colour: '색상:',
  Company: '회사',
  Confirm: '확인하다',
  ContactUs: '문의하기',
  Copied: '복사됨',
  CopiedSharedLinkInfo: '외부 입찰자 팀이나 게스트에게 링크를 공유하여 등록할 수 있도록 하세요.',
  CopyEmailsOfSelectedUsers: '선택된 사용자의 이메일 복사',
  CopyEmailsOfSelectedUsersSec2: '선택한 이메일 복사',
  CopyingAllowed: '복사 허용',
  CopyingDenied: '복사 거부됨',
  CopyingSecuritySettings: '보안 설정 복사',
  CopyLink: '링크 복사',
  CopyOf: '사본',
  CopyRegistrationLink: '등록 링크 복사',
  CopySecurity: '복사 보안',
  CopySharedLinkToClipboard: '클립보드에 링크 복사',
  CopyTeam: '복사팀',
  CreateArchive: '아카이브 만들기',
  CreateNewTeam: '새로운 팀 만들기',
  CreatePeopleWithSameEmail: '기존 사람과 동일한 이메일을 가진 사람을 만듭니다.',
  CreateSideTeam: '[Side] 팀 생성',
  CreateSubteam: '하위팀 생성',
  CreateTeam: '팀 생성',
  CreateTeamEmptyState: '사람들을 조직하고 접근 권한을 설정하기 위해 팀을 만드세요',
  CreateWatermark: '워터마크 생성',
  Daily: '일일',
  DataRoom: '데이터 룸',
  DataroomRole: '방의 역할',
  DataRooms: '데이터룸',
  DataRoomStatus: '데이터 룸 상태',
  DataRoomUserNotVerified1: '데이터룸에 접근하려면:',
  DataRoomUserNotVerified2: '초대 이메일을 엽니다',
  DataRoomUserNotVerified3: '"귀하의 세부 정보 확인" 링크를 클릭하십시오.',
  DataRoomUserNotVerified4: '로그인',
  DataRoomUserNotVerified5:
    "초대 이메일을 받지 못한 경우 데이터룸 관리자에게 문의하세요.",
  DataRoomUserNotVerifiedTitle: "귀하의 액세스가 검증되지 않았습니다.",
  DateModified: '수정된 날짜',
  DateSent: '보낸 날짜',
  Decline: '감소',
  Declined: '거절됨',
  DeclineRegistration: '등록 거부',
  Delete: '삭제',
  DeleteBidderInformation:
    "평가 프로세스에서 적격 입찰자가 아닌 경우에만 팀을 삭제할 수 있습니다. 적격 입찰자 목록에서 이 팀을 제거하세요.",
  DeleteBidderTeamInformationLine1:
   "평가 과정에서 팀이 비어 있고 적격 입찰자가 아닌 경우에만 팀을 삭제할 수 있습니다.",
  DeleteBidderTeamInformationLine2:
    '이 팀에서 사람들을 이동시키고 이 팀을 적격 입찰자 목록에서 제거하세요.',
  DeletePerson: '사람 삭제',
  DeletePersonConfirm: '사람 삭제',
  DeletePersonHeader: '[email] 을 삭제하시겠습니까?',
  DeletePersonMessage:
  '[email] 을 삭제하면 해당 토큰이 Room, 모든 활동 보고서 및 기록에서 영구적으로 제거됩니다. 이 작업은 취소할 수 없습니다.',
  DeleteRegistration: '등록 삭제',
  DeleteRequest: '요청 삭제',
  DeleteSubteam: '하위 팀 삭제',
  DeleteSubteamInformation:
    '하위 팀은 비어 있을 때만 삭제할 수 있습니다. 이 하위 팀에서 사람들을 이동하면 삭제됩니다.',
  DeleteTeam: '팀 삭제',
  DeleteTeamInformation:
    '팀은 비어 있을 때만 삭제할 수 있습니다. 이 팀에서 사람들을 이동하면 삭제됩니다.',
  DeletingTeamContainsPeople:
    '팀은 비어 있을 때만 삭제할 수 있습니다. 이 팀에서 사람들을 이동하면 삭제됩니다.',
  DemoAllCaps: '평가판',
  Deny: '부인하다',
  DenyCopyingDisabled: '복사 거부 비활성화됨',
  DenyEditingDisabled: '편집 거부 비활성화됨',
  DenyPrintingDisabled: '인쇄 거부 비활성화됨',
  DenySavingDisabled: '저장 거부 비활성화됨',
  DidntReceiveTheEmail: "이메일을 받지 못하셨나요?",
  Disable: '비활성화',
  DisableAccess: '접근 비활성화',
  Disabled: '비활성화됨',
  DisabledUser: '비활성화된 사용자',
  DisableRegistrations: '등록 비활성화',
  DisableRegistrations_SentenceCase: '등록 비활성화',
  DisableRegistrationsAction: '비활성화',
  DisableRegistrationsInformation: '비활성화하면 등록 링크가 더 이상 활성화되지 않습니다.',
  Disallowed: '허용되지 않음',
  Document: '문서',
  DocumentIndex: '문서 인덱스',
  DocumentIndexSecurity: '문서 인덱스 보안',
  Documents: '문서',
  Down: '아래에',
  Draft: '초안',
  Edit: '편집',
  EditAfterCloseDate: '마감일 이후 제출 인덱스 편집',
  EditDocumentSecurityTeam:
    '이 팀에는 인쇄 또는 저장 보안 제어, 액세스 또는 워터마크가 설정되지 않았습니다.',
  EditDocumentSecurityTeamSubteam:
    '이 하위 팀에는 인쇄 또는 저장 보안 제어, 액세스 또는 워터마크가 설정되지 않았습니다.',
  EditingAllowed: '편집 허용',
  EditingDenied: '편집 거부됨',
  EditMultipleUsers: '다중 사용자 편집',
  EditPeople: '사람 편집',
  EditPerson: '사람 수정',
  EditPersonFormInvitationMessage:
    '아래 체크박스를 클릭하여 업데이트된 이메일 주소로 새 초대장을 보내세요.',
  EditProfile: '프로필 편집',
  EditSecurity_SentenceCase: '보안 편집',
  EditSecurityFor: '보안 편집',
  EditSubteam: '하위 팀 편집',
  EditTeam: '팀 편집',
  Email: '이메일',
  EmailAddress: '이메일 주소',
  EmailCanNotBeEmpty: '이메일은 비워둘 수 없습니다',
  EmailHasBeenSent: '이메일이 전송되었습니다.',
  EmailMessage: '이메일 메시지는 필수 입력 사항입니다.',
  EmailNotifications: '이메일 알림',
  EmailNotValid: '이메일이 유효하지 않습니다',
  EmailPeople: '사람들에게 이메일 보내기',
  EmailPeopleSubjectRequiredSentenceCase: '이메일 제목은 필수입니다.',
  Emails: '이메일',
  EmailsNotValid: '이메일 [Email]이 유효하지 않습니다.',
  EmailSuccessMessage: '이메일이 성공적으로 전송되었습니다.',
  EnableAccess: '접근 허용',
  Enabled: '활성화됨',
  EnableRegistrations: '등록 활성화',
  EnableRegistrations_SentenceCase: '등록 활성화',
  EnableRegistrationsAction: '할 수 있게 하다',
  EnableRegistrationsInformation:
    '이 기능을 활성화하면 등록 링크가 활성화되어 공개적으로 공유할 수 있습니다.',
  EnterIpAddressesRanges: 'IP 주소나 IP 주소 범위를 엔터키를 눌러 구별하여 입력 하십시오.',
  EnterOneOrMoreEmailAddresses: '각 사람에 대한 이메일',
  EnterYourLocationOrClosestCity: '귀하의 위치 또는 가장 가까운 도시를 입력하세요',
  Every: '모든',
  ExpandAll_SentenceCase: '모두 확장',
  ExportToExcel_SentenceCase: 'Excel로 내보내기',
  FieldIsRequired: '[field] 이 필요합니다.',
  FieldMustBeAtMostMaxCharacters: '[field]은 최대 [max] 문자여야 합니다.',
  FileExtensionIsInList:
    '파일 "[FileName]" 은(는) 이 데이터룸에서 허용되지 않는 확장자 목록에 있기때문에 다운로드 될 수 없습니다. \r\n\r\n[FileTypeList]\r\n\r\n이 파일을 허용되는 포맷중 하나로 변경하십시오.',
  FileExtensionIsNotInList:
    '파일 "[FileName]" 은(는) 이 데이터룸에서 허용되는 확장자 목록에 있지 않기 때문에 다운로드 될 수 없습니다. \r\n\r\n[FileTypeList]\r\n\r\n이 파일을 허용되는 포맷중 하나로 변경하십시오.',
  Filter: '필터',
  FirstName: '이름',
  Folder: '폴더',
  ForRangesSeparateStartIp:
    '주소 범위는 IP 앞 부분과 뒷 부분을 줄표로 나누어 표시하십시오. (예) <b>1.1.1.1-1.1.1.6</b>',
  Friday: '금요일',
  From: '부터:',
  FullName: '이름',
  FullText: '전체 텍스트 검색',
  FullTextText: '사람들이 문서 내에서 검색할 수 있도록 허용합니다.',
  GDPRInformation: 'GDPR 정보',
  GlobalUnexpectedErrorMessage:
    "데이터룸에 문제가 있습니다. 고객 서비스 팀에 문의하세요.",
  GlobalUnexpectedErrorWithIdMessage:
    "데이터룸에 문제가 있습니다. 이 코드를 인용하세요 <[ErrorId]> 당사의 고객 서비스 팀에 문의하세요.",
  GoLiveDialogTitle: '라이브로 전환',
  GotIt: '알았어요',
  Guest: '손님',
  GuestUserRegistration: '게스트 사용자 등록',
  GuideToUsingLink: '링크 사용 가이드',
  Help: '도움말',
  HelpAndSupport: '도움말 및 지원',
  HideMenu: '메뉴 숨기기',
  High: '높은',
  History: '기록',
  Hourly: '시간당',
  IamNotReadyYet: '아직 아님',
  IamReadyToGoLive: '라이브 방송을 시작할 준비가 되었습니다',
  ID: 'ID',
  Importance: '중요성',
  Important: '중요한!',
  Important_SentenceCase: '중요한',
  Information: '정보',
  Interval: '간격',
  InvalidEmailAddress: '올바르지 않은 이메일 주소',
  InvalidField: '잘못된 [field]',
  InvalidPdf: '오류: 이 파일은 올바른 pdf문서가 아닙니다. 다른 파일로 다시 시도하십시오.',
  Invitation: '초대',
  InvitationEmail: '초대 이메일',
  InvitationSuccessMessage: '초대장이 성공적으로 전송되었습니다.',
  Invite: '초대하다',
  InviteAGuest: '손님을 초대하다',
  Invited: '초대됨',
  Invited_Users_: '초대됨',
  InvitePeople: '사람들을 초대하다',
  IpAccessList: 'IP 접근 목록',
  IpAccessList_SentenceCase: 'IP 접속 목록',
  IpAccessListCanNotBeEmpty: 'IP 액세스 목록은 비워둘 수 없습니다.',
  IpAddressInvalidIpAccessList: "IP 접속 목록의 IP '[IpAddress]' 는 유효하지 않습니다.",
  IpAddressInvalidRangeIpAccessList:
    "IP 접속 목록의 IP 범위 '[IpRange]' 는 종료 IP 주소보다 값이 큰 시작 IP 주소를 가지고 있습니다. 시작 IP 는 종료  IP보다 같거나 작아야 합니다.",
  IpLimitRangeIpAccessList:
    "IP 접속 목록의 IP 범위 '[IpRange]' 에 대한 설명을 [NumOfChars] 자로 조정해 주십시오. 이미 [UsedNumOfChars] 자를 사용하셨습니다.",
  IpUserAccessListLimit:
    'IP 접근 목록은 최대 [MaxNumberOfCharacters] 자까지 허용 됩니다. 현재 [EnteredNumberOfCharacters] 자가 입력 되었습니다.',
  IWillInviteLater: "나중에 초대할게요",
  JobTitle: '직함',
  JobTitleProfession: '직함/직업',
  Last30days: '지난 30일',
  Last7days: '지난 7일',
  LastMonth: '지난 달',
  LastName: '성',
  LastWeek: '지난주',
  LearnMore: '더 알아보기',
  LicenceChatHelp: '전문가와 상담해보세요.',
  LicenceErrorHelp: '도움이 필요하신가요? ',
  LicenceErrorMessage:
    '라이센스가 없습니다. 라이센스가 초과되면 구독이 업그레이드됩니다.',
  LicencePack: '사용자 팀 선불 팩',
  LicencePrompt:
    '보류 중인 초대장이 있을 수 있으며, 라이선스는 초대장이 수락된 후에만 사용됩니다. 초과하면 구독이 업그레이드됩니다.',
  LicenceSectionPlan: '당신의 계획',
  LicenceTooltip: '라이선스는 사람이 다음과 같은 방식으로 플랫폼에 존재할 때 소모됩니다.',
  LicenceTooltipStep1: '플랫폼 경로에서만',
  LicenceTooltipStep2: 'FAILED!',
  LicenceTooltipStep3: '둘 다',
  LicenseMessage:
    '수락된 초대는 귀하의 구독 라이선스를 사용합니다. 초과하면 귀하의 구독이 업그레이드됩니다.',
  LimitedCharacterLength: '[1] 은 [0] 문자를 초과할 수 없습니다.',
  LinkCopied: '링크 복사됨',
  LinkCopiedToClipboard: '링크가 클립보드에 복사되었습니다',
  LinkedDocuments: '연결된 문서',
  Loading: '로딩중',
  LoadingThreeDots: '로딩중...',
  Location: '위치',
  LoggedInToDate_SentenceCase: '현재까지 로그인됨',
  LoginIpAccess: '로그인 IP 접속',
  LoginLowerCase: '로그인',
  LoginsLowerCase: '로그인',
  Logout: '로그아웃',
  Low: '낮은',
  Manage: '관리',
  ManageQnaSubjects: 'Q&A 주제 관리',
  Medium: '중간',
  Message: '메시지',
  MessageEmpty: '메시지는 비워둘 수 없습니다.',
  Minute: '분',
  Minutes: '분',
  ModifiedAgo: '수정된 [time] 전',
  ModifiedBy: '수정됨',
  Monday: '월요일',
  MyAccount: '내 계정',
  Name: '이름',
  NavigateAwayConfirm: '떠나다',
  NavigateAwayWarning: '페이지를 떠나시겠습니까?',
  NavigateAwayWarningMessage: '변경한 내용은 저장되지 않습니다.',
  Never: '하지않음',
  NeverLoggedIn_SentenceCase: '로그인한 적이 없습니다',
  No: '아니오',
  NoCompanyContact: '회사 연락처 없음',
  NoDemonstration: '데모 없음',
  NonAdminSideBankruptcy: '매수 측',
  NonAdminSideBankruptcy_EmailHeading: '구매측 사람들에게 이메일 보내기',
  NonAdminSideBankruptcy_InviteHeading: '구매측 사람들에게 초대장을 보내세요',
  NonAdminSideDebt: '투자자',
  NonAdminSideDebt_EmailHeading: '투자자에게 이메일 보내기',
  NonAdminSideDebt_InviteHeading: '투자자에게 초대장을 보내세요',
  NonAdminSideDocumentRepository: '외부',
  NonAdminSideDocumentRepository_EmailHeading: '외부 이메일',
  NonAdminSideDocumentRepository_InviteHeading: '외부에 초대장 보내기',
  NonAdminSideFundraising: '금융가들',
  NonAdminSideFundraising_EmailHeading: '이메일 금융가',
  NonAdminSideFundraising_InviteHeading: '금융가들에게 초대장을 보내다',
  NonAdminSideJointVenture: '외부',
  NonAdminSideJointVenture_EmailHeading: '외부 이메일',
  NonAdminSideJointVenture_InviteHeading: '외부에 초대장 보내기',
  NonAdminSideMerger: '매수 측',
  NonAdminSideMerger_EmailHeading: '구매측 사람들에게 이메일 보내기',
  NonAdminSideMerger_InviteHeading: '구매측 사람들에게 초대장을 보내세요',
  NonAdminSideOther: '외부',
  NonAdminSideOther_EmailHeading: '외부 이메일',
  NonAdminSideOther_InviteHeading: '외부에 초대장 보내기',
  NonAdminSidePlacement: '투자자',
  NonAdminSidePlacement_EmailHeading: '투자자에게 이메일 보내기',
  NonAdminSidePlacement_InviteHeading: '투자자에게 초대장을 보내세요',
  NonAdminSidePublicOffer: '외부',
  NonAdminSidePublicOffer_EmailHeading: '외부 이메일',
  NonAdminSidePublicOffer_InviteHeading: '외부에 초대장 보내기',
  NonAdminSideTargeted: '타겟팀',
  NonAdminSideTargeted_EmailHeading: '이메일 타겟 팀',
  NonAdminSideTargeted_InviteHeading: '타겟 팀에 초대장을 보내세요',
  NonAdminSideTender: '입찰자',
  NonAdminSideTender_EmailHeading: '이메일 입찰자',
  NonAdminSideTender_InviteHeading: '입찰자에게 초대장을 보내세요',
  None: '없음',
  NoQuestionPermission: "질문 주제를 설정할 수 있는 권한이 없습니다.",
  NoQuestionSubjects: "아직 질문 주제가 없습니다.",
  NoRecordsFound: '해당 사항이 없습니다.',
  Normal: '정상',
  NoRooms: "현재 객실이 없습니다.",
  NoRoomsMatch: '객실을 찾을 수 없습니다',
  NoScorecards: "현재 스코어카드가 없습니다.",
  NoScorecardsMatch: '스코어카드를 찾을 수 없습니다',
  Notes: '노트',
  Notifications: '알림',
  NotInvited: '초대받지 않음',
  NotInvited_Users__SentenceCase: '초대받지 않음',
  NotVerified_Users__SentenceCase: '검증되지 않음',
  NotYet: '아직 아님',
  Off: '사용하지 않음',
  Ok: '좋아요',
  OK: '좋아요',
  OkAllCaps: 'OK',
  On: '~에',
  OnceOnlyAndWhenTermsAreUpdated: '단 한 번만, 약관이 업데이트될 때',
  OnEveryLogin: '매 로그인마다',
  OnfirstLogin: '첫 로그인 시',
  OnlyEnabledUsersCanBeInvited: '활성화된 사용자만 초대할 수 있습니다.',
  OnlyEnabledUsersCanBeInvitedSec2: '접근 권한이 있는 사람만 초대될 수 있습니다.',
  Optional: '선택 과목',
  Or: '또는',
  OtherTeamMembers: '[size] 다른 팀원',
  Pending: '보류 중',
  PendingScorecards: '보류 중인 스코어카드',
  PeopleFormWarningText:
    "룸 역할 '관리자'를 적용하면 사람들에게 무제한 액세스 권한이 부여됩니다. 그들은 팀의 보안 설정에 의해 제한되지 않습니다.",
  PeopleLowerCase: '사람들',
  PerDay: '하루당',
  Period: '기간',
  PerMonth: '월별',
  PersonHistory: '개인 기록',
  PersonHistoryFor: '기록하다',
  PersonLowerCase: '사람',
  PerWeek: '주당',
  Phone: '핸드폰',
  PhoneNumber: '전화 번호',
  PhoneNumber_SentenceCase: '전화 번호',
  PrintingAllowed: '인쇄 허용',
  PrintingDenied: '인쇄가 거부됨',
  Priority: '우선 사항',
  PrivacyPolicy: '개인정보 보호정책',
  Profession: '직업',
  Profile: '윤곽',
  Properties: '속성',
  ProvideBilling: '결제 세부 정보를 제공하세요',
  ProvidePayment: '결제 세부 정보를 제공하세요',
  Qna: '질문과답변',
  QnaNotificationSwitchOff: '어떠한 이메일도 수신되지 않습니다.',
  QnaNotificationSwitchOn: '즉시 업데이트를 받게 됩니다.',
  QnaRole: 'Q&A 역할',
  QnaRole_SentenceCase: 'Q&A 역할',
  QnaSubjects: 'Q&A 주제',
  QnaSubjectSecurity: 'Q&A 주제 보안',
  QnaSubmissionsLimit: '질문 제출 제한',
  QnaSubmissionsOnWeekends: '주말에 질문 제출',
  Ready: '준비가 된',
  ReasonForRequest: '요청 사유',
  Recipients: '수신자',
  RecipientsOfEmailNote_Gen2:
    "이 <nowrap>이메일</nowrap>을 받는 사람들은 서로의 이메일 주소를 볼 수 없으므로, 다른 사용자 그룹에 속한 사용자들에게 메일을 안전하게 전송할 수 있습니다.",
  Register: '등록하다',
  RegisterYourInterest: '관심등록하기',
  RegisterYourInterest_SentenceCase:
    '<strong>[dataRoomName]</strong> 관리자에게 검토를 위한 요청을 제출하세요. 등록이 수락되면 프로젝트에 초대됩니다.',
  Registration: '등록',
  Registration_LowerCase: '등록',
  RegistrationDetails: '등록 세부 정보',
  RegistrationLinkDisabled: '등록 링크 비활성화됨',
  RegistrationRequestSubmitted: '등록 요청이 제출되었습니다',
  Registrations: '등록',
  Registrations_LowerCase: '등록',
  RegistrationTextCopy:
    '입찰자 팀 또는 게스트가 관심을 등록할 수 있도록 설정했습니다. 제공된 링크를 복사하여 사람들이 등록할 수 있도록 하세요. 새로운 등록자는 이 목록에 나타나 검토하고 초대할 수 있습니다. 이 목록에 있는 사람들은 초대하고 팀에 추가할 때까지 액세스할 수 없습니다.',
  Request: '요구',
  RequestAccess: '접근 요청',
  RequestAccessDialogDescription:
    '추가 액세스가 필요한 사람에 대한 세부 정보를 제공하세요. 귀하의 요청은 관리자가 검토합니다.',
  RequestAccessDialogTitle: '추가 액세스 요청',
  RequestAccessEmptyStateText:
    '새로운 등록자는 검토할 수 있도록 이 목록에 표시됩니다. 이 목록에 있는 사람들은 관리자가 팀에 추가할 때까지 액세스할 수 없습니다.',
  RequestDetails: '요청 세부 정보',
  RequestorEmail: '요청자 이메일',
  Required: '필수의',
  ResendEmail: '이메일 재전송',
  ResendVerificationLink: '확인 링크 재전송',
  Reset: '재설정',
  Review: '검토',
  RoomRole_SentenceCase: '방의 역할',
  RoomRoleAdminSubteamHelp: '관리자는 하위 팀에 추가할 수 없습니다.',
  RoomRoleHelp: "방 역할은 방에서 사용자의 접근 수준을 결정합니다.",
  Rooms: '객실',
  RoomsAdvert1:
    "Dropbox Showcase 를 사용하면 작업을 파트너 및 고객과 원활하게 공유하고, 진행 상황을 추적하고, 누가 무엇을 봤는지 파악할 수 있습니다. 이 모든 것이 한곳에서 가능합니다.",
  RoomsAdvert2: 'Showcase는 Dropbox Business Advanced 및 Enterprise 사용자에게 제공됩니다.',
  RoomsAdvertLink: '더 알아보기',
  RoomsAdvertTitle: '고성능 거래를 실행하세요',
  Saturday: '토요일',
  Save: '저장',
  SaveAndInvitePeople: '저장하고 사람들을 초대하세요',
  Saving: '절약',
  SavingAllowed: '저장이 허용되었습니다',
  SavingDenied: '저장이 거부됨',
  SavingFailed: '저장 실패',
  Scorecards: '스코어카드',
  ScorecardsAdvert1:
    "Dropbox Showcase를 사용하면 파트너 및 고객과 작업을 원활하게 공유하고, 진행 상황을 추적하고, 누가 무엇을 봤는지 파악할 수 있습니다. 이 모든 것이 한곳에서 가능합니다.",
  ScorecardsAdvert2: 'Showcase는 Dropbox Business Advanced 및 Enterprise 사용자에게 제공됩니다.',
  ScorecardsAdvertLink: '더 알아보기',
  ScorecardsAdvertTitle: '고성능 거래를 실행하세요',
  Search: '검색',
  Secure: '안전한',
  SecureByDefault: '기본적으로 보안됨',
  SecureOffice: '안전한 사무실',
  SecureOfficeText:
    'Secure Office 는 조회수를 추적하고 Microsoft Word, Excel 및 PowerPoint 파일의 저장, 복사 및 인쇄를 비활성화할 수 있습니다.',
  SecureOfficeTitle: 'Microsoft Office 문서 보안 (Secure Office)',
  SecureOfficeWarning:
    'Secure Office 는 Apple iOS 및 Android 기기를 포함한 많은 일반 기기와 호환되지 않습니다. 이 설정은 호환되는 시스템이 없는 사용자가 이러한 파일을 볼 수 없도록 합니다.',
  Security: '보안',
  SecurityControls: '보안 제어',
  SecurityControlsOff: '보안 제어 해제',
  SecurityControlsOffDescription:
    '보안 제어가 해제되어 있으면 다운로드 후에는 이러한 문서를 사용하는 데 제한이 없습니다.',
  SecurityControlsOn: '보안 제어 켜짐',
  SecurityControlsOnDescription:
    '보안 제어가 켜지면 Microsoft Office 및 PDF 문서의 사용이 추적됩니다. 팀에 대한 액세스가 취소되거나 룸이 비활성화되면 저장된 사본이 원격으로 비활성화됩니다.',
  SecurityControlsOnExtraDescription:
    '저장, 인쇄, 편집, 복사를 제한할 수도 있습니다 (복사 제한은 Microsoft Office 문서에만 사용할 수 있습니다).',
  SecurityGroup_SentenceCase: '보안 그룹',
  SecurityPermissions: '보안 권한',
  Select: '선택',
  SelectPeople_SentenceCase: '사람을 선택하세요',
  SelectSubTeam: '하위팀을 선택해주세요.',
  SelectTeam: '팀을 선택해 주세요.',
  SelectUsers_SentenceCase: '사람을 선택하세요',
  SelectUserType: '객실 역할을 선택해 주세요.',
  SelfRegistrationHeader: '자체 등록',
  SelfRegistrationToolIntroDialogHeading: '게스트 사용자에게 등록 허용',
  SelfRegistrationToolIntroDialogHelpLink: '입찰자 등록에 대한 도움말 및 지원 보기',
  SelfRegistrationToolIntroDialogTitle1:
    '구매측/입찰자 페이지의 작업 메뉴에서 게스트 사용자 등록을 활성화합니다.',
  SelfRegistrationToolIntroDialogTitle2:
    '제공된 링크를 웹 페이지나 직접 만든 이메일에서 공유하세요.',
  SelfRegistrationToolIntroDialogTitle3: '등록된 사용자를 검토하고 초대할 수 있습니다.',
  SellSide: '판매 측',
  SellSide_InviteHeading: '판매 측 사람들에게 초대장을 보내세요',
  SellSide_SentenceCase: '판매 측',
  Send: '보내기',
  SendEmailInvitation: '이메일 초대장 보내기',
  SendEmailInvitations: '이메일 초대장 보내기',
  SendGuestInvitation: '게스트 사용자 초대장 보내기',
  SendInvitationSubjectRequiredSentenceCase: '초대 이메일에는 제목이 필요합니다.',
  SendInvite_SentenceCase: '초대장 보내기',
  SendInvites: '초대장 보내기',
  SendInviteToSubscription: '귀하의 구독에 초대합니다',
  SendUpdates: '업데이트 보내기',
  SentAgo: '[time] 을 보냈습니다.',
  SentDocumentChanged: '문서가 추가되거나 변경되면 전송됨',
  SessionTimeout: '세션 시간 초과',
  SetSecurityControls: '보안 제어 설정',
  SetSecurityControlsBeforeAddingPeople: '사람을 추가하기 전에 보안 제어를 설정하세요.',
  SetSubmissionLimits: '제출 한도 설정',
  SetSubmissionLimitsDescription:
    '팀이 하루, 주 또는 월별로 질문할 수 있는 질문 수를 제한합니다.',
  ShouldBeEmailEmail: '입력하신 이메일 주소는 유효하지 않습니다.',
  ShowActivityInReports_SentenceCase: '보고서에서 활동 표시',
  ShowDetails: '세부 정보 표시',
  ShowMore: '더 보기',
  Status: '상태',
  StayOnPage: '설정이 복사되는 동안 이 화면에 머물러 주세요.',
  Subject: '주제',
  Subject_Email_: '주제',
  SubjectEmailHint: '이메일 제목은 필수 입력 사항입니다.',
  SubjectGroupNotSet: '주제 그룹이 설정되지 않았습니다',
  SubmissionIndex: '제출 인덱스',
  SubmissionIndexesSecurity: '제출 인덱스 보안',
  SubmissionIndexTopLevelFoldersSecurity: '제출 인덱스 최상위 폴더 보안',
  Submissions: '제출',
  SubTeam: '하위팀',
  SubteamName: '하위팀 이름',
  SubTeamNameAlreadyExists: '같은 이름의 하위 팀이 이미 존재합니다.',
  SubteamNameValidation: '하위 팀 이름은 비워둘 수 없습니다.',
  Success: '성공',
  Sunday: '일요일',
  SwitchTeam_Confirm: '네, 팀을 바꾸세요',
  SwitchTeam_Title: '팀을 바꾸다',
  SwitchTeam_WarningMessage:
    '몇 가지 변경을 한 것 같습니다. 저장하지 않고 나가면 변경 사항이 손실됩니다.',
  SydneyTime: '시드니 시간',
  TalkToAnsaradaNow: '지금 Ansarada와 대화하세요',
  Team: '팀',
  TeamColour: '팀 컬러 – [colour]',
  TeamHistory: '팀 기록',
  TeamHistoryFor: '팀 기록',
  TeamMemberEmails: '팀원 이메일',
  TeamMemberEmailsInfo:
    '세미콜론이나 쉼표로 구분된 팀원의 이메일. 등록이 수락되면 모두 초대됩니다.',
  TeamName: '팀 이름',
  TeamNameAlreadyExists: '같은 이름의 팀이 이미 존재합니다.',
  TeamNameValidation: '팀 이름은 비워둘 수 없습니다.',
  TeamPermissions: '팀 권한',
  TenderFreemiumDialogBannerTitle: '첫 번째 투숙객이 초대되면 요금 청구가 시작됩니다.',
  TenderFreemiumDialogContent:
    '입찰 팀에 초대장을 보내면 조달의 첫 번째 단계에서 라이브로 전환할 수 있습니다. 필요한 만큼 많은 입찰자를 초대할 수 있습니다.',
  TenderFreemiumDialogSubContent:
  'Ansarada Sales 팀이 귀하의 팀에 연락하여 이 과정을 도와드릴 것입니다.',
  TermsAndConditions: '이용약관',
  TheSafestWayToEnterEmails:
    '이메일을 입력하는 가장 안전한 방법은 복사하여 붙여넣는 것입니다. 각 이메일 주소가 쉼표, 세미콜론, 공백 또는 줄 바꿈으로 구분되어 있는지 확인하세요.',
  ThirdPartyIntegrations_SentenceCase: '타사 통합',
  ThirdPartyIntegrationsText: '타사 통합을 모두 허용하거나, 일부만 허용하거나, 전혀 허용하지 않습니다.',
  ThisSubTeamCannotAccess: '이 하위 팀은 어떠한 폴더나 문서에도 접근할 수 없습니다.',
  ThisTeamCannotAccess: '이 팀은 어떤 폴더나 문서에도 접근할 수 없습니다.',
  Thursday: '목요일',
  Time: '시간',
  TimePeriodAm: '오전',
  TimePeriodPm: '오후',
  To: '까지:',
  ToBeAbleToInvitePeopleToYourDataRoom: '사람들을 데이터룸에 초대할 수 있습니다.',
  Today: '오늘',
  ToInviteFirstGuestAndGoLive: '첫 번째 게스트 사용자를 초대하고 라이브로 전환하세요',
  Topic: '[토픽] 토픽',
  Topics: '[토픽] 토픽',
  Total: '총',
  Translation_SentenceCase: '번역',
  TranslationSettingText:
    '우리는 AI 를 사용하여 즉석에서 문서를 번역합니다. 문서를 검토할 때 번역을 확인하세요.',
  TranslationTitle: 'AI를 사용하여 문서 내용 번역',
  Tuesday: '화요일',
  Unknown: '알려지지 않은',
  Up: '위로',
  Update: '업데이트',
  UserCanLogInFromAnyIp: '이 사용자는 모든 IP주소에서 로그인 할 수 있습니다.',
  UserCanLogInOnlyFromIpsBelow: '이 사용자는 아래의 IP 주소에서만 로그인 할 수 있습니다.',
  UserExistsWithEmail: '사용자는 이메일 [0]을 사용하여 존재합니다.',
  UserGroup: '사용자 그룹',
  UserInvitationLinkNote_Gen2:
    '"[invitation_link]" 태그는 이메일이 전송될 때 생성된 하이퍼링크로 대체됩니다. 이메일 본문에 있어야 합니다.',
  UserInvitationLinkTagIsMissing:
    '액세스 링크 없이는 초대 이메일을 보낼 수 없습니다. [invitation_link] 을 괄호로 복사하여 수신자가 액세스를 생성할 수 있도록 메시지에 추가하세요.',
  UserProperties: '사용자 속성',
  UserStatus: '사용자 상태',
  UserType: '사용자 유형',
  UserTypeError: '방 역할이 필요합니다',
  UserUpdated: '사람들이 성공적으로 업데이트되었습니다.',
  Verified: '검증됨',
  Verified_Users_: '확인됨',
  VerifyYourEmail: '이메일을 확인하세요',
  VerifyYourEmailAddressToInviteUsers: '사용자를 초대하려면 이메일 주소를 확인하세요.',
  View: '보기',
  ViewDetails: '자세한 내용 보기',
  ViewIndexAsGhost: '그들은 무엇을 볼 수 있나요?',
  ViewSecurity: '보안 보기',
  Warning: '경고',
  Watermark: '워터마크',
  Wednesday: '수요일',
  Weekly: '주간',
  WeHaveSentTheVerificationLinkTo: "[email]에 검증 링크를 보냈습니다.",
  Yes: '예',
  YouCanAddDescriptionsAfterComma:
    '쉼표 뒤에는 설명을 첨부할 수도 있습니다. (예) <b>1.1.1.1, 런던 사무소 IP</b>',
  YourCurrentIpAddress:
    '<b>참고:</b> 귀하의 현재 IP 주소는 [IP Address] 입니다. 목록에 추가하시려면 <a [href]>여기</a>를 클릭하십시오.',
  YourCurrentIpAddressSec2: '현재 IP 주소를 허용 목록에 추가하세요.',
  YouWillReceiveAConfirmationInYourEmailAboutNextSteps:
    "다음 단계에 대한 확인은 이메일로 전송됩니다.",
};
